import React, { Component } from 'react'

class LogoHeader extends Component {
  render() {
    return (
      <div className="w-logo mt3">
        <img src="images/VTEX_logo.png" alt="logo" />
      </div>
    )
  }
}

export default LogoHeader



// WEBPACK FOOTER //
// ./src/components/LogoHeader.js